module.exports = __webpack_public_path__ + "static/media/level1_q1.701d671a.png";